import { render, staticRenderFns } from "./CompanyManagementScreen.vue?vue&type=template&id=2be2ac06&scoped=true&"
import script from "./CompanyManagementScreen.vue?vue&type=script&lang=js&"
export * from "./CompanyManagementScreen.vue?vue&type=script&lang=js&"
import style0 from "./CompanyManagementScreen.vue?vue&type=style&index=0&id=2be2ac06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be2ac06",
  null
  
)

export default component.exports